import { render } from "./Tabulator.vue?vue&type=template&id=5dd93c54"
import script from "./Tabulator.vue?vue&type=script&lang=js"
export * from "./Tabulator.vue?vue&type=script&lang=js"

import "./Tabulator.vue?vue&type=style&index=0&id=5dd93c54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__